import { onAnalyticsReady } from 'uplisting-frontend/utils';

// we need this for testing purposes, stubbing function doesn't work, because of that - we have it as a object with method
export const windowHelper = {
  getLocationSearch(): string {
    return window.location.search;
  },
};

// we need this for testing purposes, stubbing function doesn't work, because of that - we have it as a object with method
export const analyticsHelper = {
  analyticsIdentify(...args): void {
    window.analytics?.identify(...args);
  },
};

function trackUtmParams(): void {
  const locationSearch = windowHelper.getLocationSearch();

  if (!locationSearch) {
    return;
  }

  const urlParams = new URLSearchParams(locationSearch);

  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');
  const utmTerm = urlParams.get('utm_term');
  const utmContent = urlParams.get('utm_content');

  if (!(utmSource || utmMedium || utmCampaign || utmTerm || utmContent)) {
    return;
  }

  const args: (string | object)[] = [];

  if (typeof window.analytics?.user !== 'function') {
    return;
  }

  const userId = window.analytics?.user().id();

  if (userId) {
    args.push(userId);
  }

  args.push({
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_term: utmTerm,
    utm_content: utmContent,
  });

  analyticsHelper.analyticsIdentify(...args);
}

export function initialize() {
  onAnalyticsReady(trackUtmParams);
}

export default {
  name: 'tracking',
  initialize,
};
